// Copyright (c) 2022 Siemens

/**
 * @module js/DesCatalogImagesViewService
 */

import eventBus from 'js/eventBus';

const desCatalogListSelectionChange = 'des-catalog-images-view.selectionChange'

// ACC
const DES_CATALOG_IMAGES_VIEW_ACC = "des-catalog-images-view";
const DES_CATALOG_PART_LIST_ACC = "des-catalog-part-list";
const DES_CATALOG_SEARCH_RESULTS_ACC = "des-catalog-search-results";
const COMPACT = "compact";
const CUSTOM = "custom";
const STYLING_CLASS_FOR_COMPACT = ".des-compact-imagecell-container";
const STYLING_CLASS_FOR_CUSTOM = ".des-catalog-custom-image-container";

export const showCatalogParts = (vmo, selectedCatalog) => {
    const {
        data,
        dispatch
    } = vmo;

    data.showCatalogPartsList = true;
    data.selectedCatalog = selectedCatalog[0].id2;

    dispatch({
        path: 'data',
        value: {
            ...data
        }
    });
}

export const getProviderLabel = (vmo, provider) => {
    const {
        data,
        dispatch
    } = vmo;

    if (provider === 'CADENAS') {
        data.label = 'Cadenas Catalogs';
    } else if (provider === 'DES') {
        data.label = 'Siemens Catalogs';
    }

    dispatch({
        path: 'data',
        value: {
            ...data
        }
    });
}

export const setNextValueForPagination = (vmo, skip) => {
    const {
        data,
        dispatch
    } = vmo;
    data.next = skip;
    dispatch({
        path: 'data',
        value: {
            ...data
        }
    });
}

export const refreshCatalogImagesList = (vmo) => {
    // Set the next value to 0 as need to make the refresh call instead of getting paginated calls
    const { data, dispatch } = vmo;
    data.next = 0;
    if (typeof dispatch === 'function') {
        dispatch({ path: 'data', value: { ...data } });
        eventBus.publish('des-refreshCatalogImagesList');
    } else {
        console.log('refreshCatalogImagesList_vmo', vmo);
    }
}

export const setFirstCatalogSelection = (autoSelectFirst, data) => {
    if (autoSelectFirst === 'true') {
        const loadedVMCollection = data.dataProviders.catalogImages.getViewModelCollection();
        const vmToSelect = loadedVMCollection.getViewModelObject(0);
        if (vmToSelect) {
            data.dataProviders.catalogImages.selectionModel.setSelection(vmToSelect);
        } else {
            console.log('No record to auto select.')
        }
    }
}

export const subscribeRefreshCatalogList = (vmo) => {
    window.addEventListener(
        'setStatus-refreshCatalogList',
        () => refreshCatalogImagesList(vmo),
        false
    );
}

// Intersection Observer
const callback = (cellEntries, observer) => {
    cellEntries.forEach((cell) => {
        if (cell.isIntersecting) {
            const lazyImage = cell.target;
            // Check if the image has already been loaded
            if (!lazyImage.dataset.loaded || lazyImage.dataset.loaded === "false") {
                // Remove the skeleton loading effect after image is loaded
                // Set the src attribute
                lazyImage.src = lazyImage.dataset.src;
                lazyImage.dataset.loaded = true; // Mark the image as loaded
                lazyImage.classList.remove('des-image-cell-skeleton-loading');
            }
            lazyImageObserver.unobserve(lazyImage);
        }
    })
};

// trigger event when last item is at least 10% visible
const options = {
    threshold: 0.1
};

const lazyImageObserver = new IntersectionObserver(callback, options);

export const initIntersectionObserver = (imageObjects, provider, acc, vmo, display) => {
    /**  Select the all conatainers uniquely with
     provider which are available in DOM **/
    const ACC_VIEW = getAccView(acc);
    let lazyImagesContainers = document.querySelectorAll(`${ACC_VIEW}[provider="${provider}"] .sw-pic-container.sw-imagecell-thumbnail`);
    if(lazyImagesContainers.length === 0){
        let imgeContainerClass = '';
        switch(display){
            case COMPACT:
                imgeContainerClass = STYLING_CLASS_FOR_COMPACT ;
                break;
            case CUSTOM:
                imgeContainerClass = STYLING_CLASS_FOR_CUSTOM;
                break;
            default:
                break;
        }
        lazyImagesContainers = document.querySelectorAll(`${ACC_VIEW}[provider="${provider}"] ${imgeContainerClass}`);
    }
    /** Observe all the non-loaded images using the observer
        and set the src for them with help of counter  **/
    let count = 0;
    const { data, dispatch } = vmo;
    if (imageObjects?.length !== 0) {
        lazyImagesContainers.forEach(function (lazyImagesContainer) {
            // Get <img> element from container
            const imgElement = lazyImagesContainer.querySelector('img');
            imgElement.classList.add('des-image-cell-skeleton-loading');  // add the skeleton loading css

            // when call from event subscription
            if (data.resetAttributes) {
                imgElement.dataset.loaded = false;
            }
            if (!imgElement.dataset.loaded || imgElement.dataset.loaded === "false") {
                // Empty the icon image
                imgElement.src = '';
                imgElement.alt = '';
                imgElement.dataset.src = imageObjects[count].filePath;
                count++;
            }
            // Do not observe alredy loaded image
            if (!imgElement.dataset.loaded || imgElement.dataset.loaded === "false") {
                lazyImageObserver.observe(imgElement);
            }
        });
        data.resetAttributes = false;
        dispatch({ path: 'data', value: { ...data } });
    }
}

export const disconnectIntersectionObserver = () => {
    lazyImageObserver.disconnect();
}


const getAccView = (acc) => {
    switch (acc) {
        case DES_CATALOG_IMAGES_VIEW_ACC:
            return DES_CATALOG_IMAGES_VIEW_ACC;
        case DES_CATALOG_PART_LIST_ACC:
            return DES_CATALOG_PART_LIST_ACC;
        case DES_CATALOG_SEARCH_RESULTS_ACC:
            return DES_CATALOG_SEARCH_RESULTS_ACC;
        default:
            return '';
    }
}
